export enum UserConstants {
  USER_DEPARTMENT_ID = "user-department-id",
}
